"use strict";
exports.intervalToDuration = intervalToDuration;
var _index = require("./add.js");
var _index2 = require("./differenceInDays.js");
var _index3 = require("./differenceInHours.js");
var _index4 = require("./differenceInMinutes.js");
var _index5 = require("./differenceInMonths.js");
var _index6 = require("./differenceInSeconds.js");
var _index7 = require("./differenceInYears.js");
var _index8 = require("./toDate.js");
function intervalToDuration(interval) {
  const start = (0, _index8.toDate)(interval.start);
  const end = (0, _index8.toDate)(interval.end);
  const duration = {};
  const years = (0, _index7.differenceInYears)(end, start);
  if (years) duration.years = years;
  const remainingMonths = (0, _index.add)(start, { years: duration.years });
  const months = (0, _index5.differenceInMonths)(end, remainingMonths);
  if (months) duration.months = months;
  const remainingDays = (0, _index.add)(remainingMonths, {
    months: duration.months
  });
  const days = (0, _index2.differenceInDays)(end, remainingDays);
  if (days) duration.days = days;
  const remainingHours = (0, _index.add)(remainingDays, {
    days: duration.days
  });
  const hours = (0, _index3.differenceInHours)(end, remainingHours);
  if (hours) duration.hours = hours;
  const remainingMinutes = (0, _index.add)(remainingHours, {
    hours: duration.hours
  });
  const minutes = (0, _index4.differenceInMinutes)(end, remainingMinutes);
  if (minutes) duration.minutes = minutes;
  const remainingSeconds = (0, _index.add)(remainingMinutes, {
    minutes: duration.minutes
  });
  const seconds = (0, _index6.differenceInSeconds)(end, remainingSeconds);
  if (seconds) duration.seconds = seconds;
  return duration;
}
